import React from 'react';

function Header() {

    return(
        <div>
            <h1>TaskEase</h1>
        </div>
        
    )
}

export default Header;
